const config = {
  api: {
    default: 'v1',
    v1: 'v1',
    v2: 'v2',
  },
  basename: '/',
  apptype: 'operator',
  mapbox: {
    parsimap: {
      setRTLTextPlugin:
        'https://cdn.parsimap.ir/third-party/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
      mapboxApiAccessToken: 'cc36b44185e1426982743f83178ed5a6',
      mapStyle:
        'https://api.parsimap.ir/styles/parsimap-streets-v11?key=cc36b44185e1426982743f83178ed5a6',
    },
    mapgl: {
      setRTLTextPlugin:
        'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
      mapboxApiAccessToken:
        'pk.eyJ1IjoibXJiYXlhdDYiLCJhIjoiY2toejJibnQ2MGFrYzJ5b2g2dXZ2YXNwOCJ9.HXgP0IjL6CRFdL4UhidZPQ',
      mapStyle: 'mapbox://styles/mapbox/streets-v11',
    },
    dragRotate: true,
    attributionControl: false,
    zoom: 14,
    bearing: 0,
    pitch: 0,
    offsetTop: -30,
    offsetLeft: -15,
    minZoom: 10,
  },
  latitude: 35.734251,
  longitude: 51.381695,
  currentAppLocale: 'fa',
  authorizationType: 'Bearer ',
  statusFuelRequestOnline: 3000,
  snackbarAutoHideDuration: 3000,
  onlineFuelRequestInprocessLoading: 20000,
  ipDataToken: '5ad9b4f3e18adcf6b3e31903638a3bc62e8145d5d1c7d302bb1eaf64',
};

export default config;
